query ListRecentBimClassesAndGeometryTypes {
    recentBimClasses {
        id

        revisionID

        data {
            name(language: "en") {
                text
            }
        }
    }
    recentGeometryTypes {
        id

        revisionID

        name(language: "en") {
            text
        }

        bimClass(resolution: ["latest"]) {
            id

            revisionID

            data {
                name(language: "en") {
                    text
                }
            }
        }
    }
}
